import React from "react"
import { MdOutlineAdminPanelSettings, MdOutlineRefresh } from "react-icons/md"
import Button from "../../../components/Form/Button"
import styles from "./onboarding.module.css"

const PendingSetup = ({ onRefresh = () => { } }) => (
    <div className={styles.pendingSetup}>
        <div className={styles.pendingIcon}><MdOutlineAdminPanelSettings /></div>
        <span className={styles.pendingEyebrow}>Configuração em andamento</span>
        <h1>Um administrador precisa concluir a preparação da conta</h1>
        <p>
            O funil e os padrões comerciais ainda não foram finalizados. Para evitar configurações
            incompletas, essa etapa deve ser concluída por um usuário com acesso a <strong>Funis</strong> e <strong>Configurações</strong>.
        </p>
        <div className={styles.pendingInfo}>
            <strong>O que acontece depois?</strong>
            <span>Assim que a configuração terminar, você verá seu tutorial individual e poderá começar a usar a plataforma.</span>
        </div>
        <Button variant="secondary" fullWidth={false} onClick={onRefresh}><MdOutlineRefresh /> Verificar novamente</Button>
    </div>
)

export default PendingSetup
